export default __webpack_public_path__ + "static/media/kitchen5-beforeE.3a076054.jpg";